export default __webpack_public_path__ + "static/media/atom.1651bc53.svg";